var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBandagedHead = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 124,
  height: 124
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bandaged-head_svg__a",
  x1: "110.175%",
  x2: "50%",
  y1: "241.368%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4D409C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "69.968%",
  stopColor: "#079FD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#32B57E"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#bandaged-head_svg__a)",
  d: "M62 124C27.758 124 0 96.242 0 62S27.758 0 62 0s62 27.758 62 62c-.039 34.226-27.774 61.961-62 62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M43.096 98.636a2.818 2.818 0 0 1-2.1-4.698 28.18 28.18 0 0 1 42.008 0 2.818 2.818 0 1 1-4.2 3.76 22.545 22.545 0 0 0-33.609 0 2.82 2.82 0 0 1-2.1.938M98.636 56.364a2.82 2.82 0 0 0-2.818 2.818 5.636 5.636 0 1 1-11.273 0 2.818 2.818 0 1 0-5.636 0c0 6.226 5.047 11.273 11.273 11.273s11.273-5.047 11.273-11.273a2.82 2.82 0 0 0-2.819-2.818M25.364 56.364a2.82 2.82 0 0 1 2.818 2.818 5.636 5.636 0 1 0 11.273 0 2.818 2.818 0 1 1 5.636 0c0 6.226-5.047 11.273-11.273 11.273s-11.273-5.047-11.273-11.273a2.82 2.82 0 0 1 2.819-2.818"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "m6.056 35.292 114.311 5.811a62.3 62.3 0 0 0-22.1-29.343L31 8.342a62.4 62.4 0 0 0-24.944 26.95"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3B3B3",
  d: "m23.602 36.183 41.247 2.096 41.444-19.55a62.6 62.6 0 0 0-8.026-6.969l-20.663-1.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "m66.371.172-54.816 25.86A61.65 61.65 0 0 0 0 62c0 .211 0 .42.017.631l101.866-48.05A61.7 61.7 0 0 0 66.37.171"
}))));
export default SvgBandagedHead;